(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["db-free-ebook-pitch"]) return;
  try {
    
/* === Testimonials Rotator === */
(function() {
  var root = document.currentScript.closest('.dbcrew-panel');
  if (!root) return;

  var items = [].slice.call(root.querySelectorAll('.dbcrew-t-item'));
  if (items.length <= 1) return;

  var dots = root.querySelector('.dbcrew-t-dots');
  var idx = 0;
  var delay = parseInt(root.querySelector('.dbcrew-testimonials').dataset.rotate || '5000', 10);

  function go(i) {
    items[idx].setAttribute('aria-hidden', 'true');
    idx = i;
    items[idx].setAttribute('aria-hidden', 'false');
    setDots();
  }

  function setDots() {
    if (!dots) return;
    dots.innerHTML = '';
    items.forEach(function(_, i) {
      var b = document.createElement('button');
      if (i === idx) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', function() {
        go(i);
        restart();
      });
      dots.appendChild(b);
    });
  }

  function next() {
    go((idx + 1) % items.length);
  }

  var t = setInterval(next, delay);
  function restart() {
    clearInterval(t);
    t = setInterval(next, delay);
  }

  setDots();
})();

/* === Omnisend Popup Trigger === */
document.addEventListener("DOMContentLoaded", function() {
  var btn = document.getElementById("dbcrew-download-btn");
  if (!btn) return;

  btn.addEventListener("click", function(e) {
    e.preventDefault(); // Stop any link behavior

    function openForm() {
      if (window.omnisend && typeof window.omnisend.push === "function") {
        // ✅ Immediately open your Omnisend popup
        window.omnisend.push(["openForm", "68e4cc5b4552426789be57ee"]);
      } else {
        console.warn("Omnisend not ready yet... retrying");
        setTimeout(openForm, 500);
      }
    }

    openForm();
  });
});

  } catch(e) { console.error(e); }
})();
})();
